.filing-version-custom-tooltip{padding:15px;font-size:.95rem!important}
/*# sourceMappingURL=create-filing-dialog.component-PH4KD5CF.css.map */
